import PropTypes from 'prop-types';

import { socialMediaTypeArray } from 'sharedParts/config/socialMediaConfig';

export const socialButtonPropType = PropTypes.shape({
  anchor: PropTypes.string,
  url: PropTypes.string,
  value: PropTypes.oneOf(socialMediaTypeArray),
});

export const socialButtonsArrayPropType = PropTypes.arrayOf(
  socialButtonPropType,
);
